<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 40"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99995 17.5988V12.7988C4.99995 9.61623 6.26423 6.56398 8.51467 4.31355C10.7651 2.06311 13.8174 0.798828 17 0.798828C20.1825 0.798828 23.2348 2.06311 25.4852 4.31355C27.7357 6.56398 29 9.61623 29 12.7988V17.5988C30.273 17.5988 31.4939 18.1045 32.3941 19.0047C33.2942 19.9049 33.7999 21.1258 33.7999 22.3988V34.3988C33.7999 35.6719 33.2942 36.8928 32.3941 37.7929C31.4939 38.6931 30.273 39.1988 29 39.1988H4.99995C3.72691 39.1988 2.50601 38.6931 1.60584 37.7929C0.705664 36.8928 0.199951 35.6719 0.199951 34.3988V22.3988C0.199951 21.1258 0.705664 19.9049 1.60584 19.0047C2.50601 18.1045 3.72691 17.5988 4.99995 17.5988ZM24.1999 12.7988V17.5988H9.79995V12.7988C9.79995 10.8893 10.5585 9.05792 11.9088 7.70766C13.259 6.3574 15.0904 5.59883 17 5.59883C18.9095 5.59883 20.7409 6.3574 22.0911 7.70766C23.4414 9.05792 24.1999 10.8893 24.1999 12.7988Z"
    />
  </svg>


</template>

<script lang="ts">
export default {
  name: "IconBadgeCheck",
  props: ["height", "width"],
}
</script>
